import React from "react";

const ResponsiveTable = ({children, className}) => {
    return (
        <div className={"responsive-table overflowAuto " + (className || '')}>
            <div className="inner-container wt-max-content min-wt-100p">
                {children}
            </div>
        </div>
    );
};

export default ResponsiveTable;